import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-vh-80" }
const _hoisted_2 = { key: 0 }

import { onMounted, ref, computed } from 'vue'
import { eventoService } from '@/services/evento.service'
import DetailSeccion from '@/views/detail/DetailSeccion.vue'
import DetailSeccionSpecial from '@/views/detail/DetailSeccionSpecial.vue'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import TheSliderFull from '@/components/rebranding/TheSliderFull.vue'
import TheDescripcionEvento from '@/components/rebranding/TheDescripcionEvento.vue'
import TheDestacadoMes from '@/components/rebranding/TheDestacadoMes.vue'
import TheBeneficios from '@/components/rebranding/TheBeneficios.vue'
import TheExperiencias from '@/components/rebranding/TheExperiencias.vue'
import TheNovedades from '@/components/rebranding/TheNovedades.vue'
import { EstructuraSitio } from '@/interfaces/SitioEstructura'


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const loading = ref(true)
const eventoVer = ref()
const { state, commit } = useStore<VuexStore>(key)

const setMetaTags = (nombre?: string, descripcion?: string) => {
  if (nombre) document.title = nombre
  let meta = document.querySelector('meta[name="description"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    document.head.appendChild(meta)
  }
  if (descripcion) meta.setAttribute('content', descripcion.replace(/<[^>]+>/g, ''))
}

const resolveRequest = async () => {
  loading.value = true
  eventoVer.value = await eventoService.ver()
  loading.value = false
  commit('RESET_NAV')
  setMetaTags(eventoVer.value?.nombre, eventoVer.value?.descripcion)
}

onMounted(() => {
  resolveRequest()
})

const mensajesBienvenida: Record<string, string> = {
  fiat_fidelizacion: '¡BIENVENIDO A CLUB PASSIONE!',
  citroen_fidelizacion_rebranding: 'VIVÍ A PLENO EL MUNDO DE CITROËN CLUB',
  ram: 'EL PODER DE PERTENECER',
  jeep_fidelizacion: 'VIVÍ LA AVENTURA DE JEEP WAVE',
  peugeot_fidelizacion: 'TE DAMOS LA BIENVENIDA A PEUGEOT LIONS',
  ds_fidelizacion: 'ONLY YOU, EL UNIVERSO DS PARA VOS',
  abarth: 'ONLY FOR REAL ABARTHISTI'
}

const theme = computed(() => state.evento?.theme)

const mensajeBienvenida = computed(() => {
  return mensajesBienvenida[theme.value] || '¡BIENVENIDOS!'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (eventoVer.value && _unref(state).evento)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (eventoVer.value.slider.length)
            ? (_openBlock(), _createBlock(TheSliderFull, {
                key: 0,
                imgs: eventoVer.value.slider,
                video: eventoVer.value.video
              }, null, 8, ["imgs", "video"]))
            : _createCommentVNode("", true),
          (eventoVer.value.nombre)
            ? (_openBlock(), _createBlock(TheDescripcionEvento, {
                key: 1,
                title: _unref(mensajeBienvenida),
                "sub-title": eventoVer.value.subtitulo,
                html: eventoVer.value.descripcion
              }, null, 8, ["title", "sub-title", "html"]))
            : _createCommentVNode("", true),
          (_unref(state).evento.estructura[_unref(EstructuraSitio).DESTACADOS])
            ? (_openBlock(), _createBlock(TheDestacadoMes, {
                key: 2,
                total: _unref(state).evento.estructura[_unref(EstructuraSitio).DESTACADOS]
              }, null, 8, ["total"]))
            : _createCommentVNode("", true),
          (_unref(state).evento.estructura[_unref(EstructuraSitio).EXPERIENCIAS])
            ? (_openBlock(), _createBlock(TheExperiencias, {
                key: 3,
                total: _unref(state).evento.estructura[_unref(EstructuraSitio).EXPERIENCIAS]
              }, null, 8, ["total"]))
            : _createCommentVNode("", true),
          (_unref(state).evento.estructura[_unref(EstructuraSitio).BENEFICIOS])
            ? (_openBlock(), _createBlock(TheBeneficios, {
                key: 4,
                total: _unref(state).evento.estructura[_unref(EstructuraSitio).BENEFICIOS]
              }, null, 8, ["total"]))
            : _createCommentVNode("", true),
          (_unref(state).evento.estructura[_unref(EstructuraSitio).NOVEDADES])
            ? (_openBlock(), _createBlock(TheNovedades, {
                key: 5,
                total: _unref(state).evento.estructura[_unref(EstructuraSitio).NOVEDADES]
              }, null, 8, ["total"]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (_unref(state).evento?.fidelizacion)
                  ? (_openBlock(), _createBlock(DetailSeccionSpecial, {
                      key: 0,
                      video: eventoVer.value.id === 14 ? '/video/promo_14.mp4' : (eventoVer.value.id === 179 ? '/video/promo_179.mp4' : (eventoVer.value.id === 145 ? '/video/promo_145.mp4' : undefined)),
                      title: eventoVer.value.nombre,
                      "sub-title": eventoVer.value.subtitulo,
                      imgs: eventoVer.value.slider,
                      html: eventoVer.value.descripcion
                    }, null, 8, ["video", "title", "sub-title", "imgs", "html"]))
                  : (_openBlock(), _createBlock(DetailSeccion, {
                      key: 1,
                      title: eventoVer.value.nombre,
                      "sub-title": eventoVer.value.subtitulo,
                      imgs: eventoVer.value.slider,
                      html: eventoVer.value.descripcion
                    }, null, 8, ["title", "sub-title", "imgs", "html"]))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})